import { makeStyles } from '@material-ui/core';

import {
  EntityKindPicker,
  EntityTypePicker,
  UserListPicker,
  EntityOwnerPicker,
  EntityLifecyclePicker,
  EntityTagPicker,
  EntityProcessingStatusPicker,
  EntityNamespacePicker,
} from '@backstage/plugin-catalog-react';

const useStyles = makeStyles(theme => ({
  root: {
    minHeight: 40,
  },
  separator: {
    marginTop: theme.spacing(3),
    paddingTop: theme.spacing(2),
    borderTop: `2px solid ${theme.palette.divider}`,
  },
  quickAccessTitle: {
    fontFamily: "'Poppins', sans-serif",
    fontSize: '0.6875rem',
    fontWeight: 600,
    color: theme.palette.text.secondary,
    textTransform: 'uppercase',
    letterSpacing: '0.08em',
    marginBottom: theme.spacing(1),
  },
}));

/**
 * Conteúdo do painel de filtros do catálogo. Renderizado dentro do drawer de
 * `CatalogFilterLayout.Filters`, que já traz o título "Filtros"; por isso não
 * há cabeçalho próprio aqui.
 */
export const CollapsibleFilters = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <EntityKindPicker initialFilter="system" />
      <EntityTypePicker />
      <EntityOwnerPicker mode="owners-only" />
      <EntityLifecyclePicker />
      <EntityTagPicker />
      <EntityProcessingStatusPicker />
      <EntityNamespacePicker />
      <div className={classes.separator}>
        <span className={classes.quickAccessTitle}>Acesso Rapido</span>
        <UserListPicker initialFilter="all" />
      </div>
    </div>
  );
};
